var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCiscoMerakiLogoGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.5 27.2",
    style: {
      enableBackground: "new 0 0 141.5 27.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#929497;}\n  .st1{fill:#66B245;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 18.1,
    className: "st0",
    width: 2.3,
    height: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.2,20.7c-0.1,0-0.8-0.5-1.9-0.5c-1.5,0-2.5,1-2.5,2.4c0,1.3,1,2.4,2.5,2.4c1.1,0,1.8-0.4,1.9-0.5V27       c-0.3,0.1-1.1,0.3-2.1,0.3c-2.6,0-4.8-1.8-4.8-4.7c0-2.7,2-4.7,4.8-4.7c1.1,0,1.9,0.3,2.1,0.3V20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.5,20.7c-0.1,0-0.8-0.5-1.9-0.5c-1.5,0-2.5,1-2.5,2.4c0,1.3,1,2.4,2.5,2.4c1.1,0,1.8-0.4,1.9-0.5V27       c-0.3,0.1-1.1,0.3-2.1,0.3c-2.6,0-4.8-1.8-4.8-4.7c0-2.7,2-4.7,4.8-4.7c1.1,0,1.9,0.3,2.1,0.3V20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,20.3c-1.3,0-2.3,1.1-2.3,2.4c0,1.3,1,2.4,2.3,2.4c1.3,0,2.4-1.1,2.4-2.4C44.7,21.3,43.7,20.3,42.4,20.3        M47.1,22.6c0,2.6-2,4.7-4.8,4.7c-2.8,0-4.8-2.1-4.8-4.7c0-2.6,2-4.7,4.8-4.7C45.2,18,47.1,20.1,47.1,22.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.5,20.2c0,0-1-0.3-1.8-0.3c-0.9,0-1.4,0.3-1.4,0.7c0,0.5,0.7,0.7,1,0.9l0.6,0.2c1.5,0.5,2.1,1.5,2.1,2.6       c0,2.3-2,3-3.7,3c-1.2,0-2.3-0.2-2.5-0.2V25c0.2,0,1.2,0.3,2.1,0.3c1.1,0,1.7-0.3,1.7-0.8c0-0.5-0.4-0.7-1-0.9       c-0.1,0-0.3-0.1-0.5-0.2C21,23,20,22.3,20,20.8c0-1.7,1.3-2.8,3.4-2.8c1.1,0,2.1,0.3,2.2,0.3V20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,8.5c0-0.6-0.5-1.1-1.1-1.1C0.5,7.3,0,7.8,0,8.5v2.4C0,11.5,0.5,12,1.1,12c0.6,0,1.1-0.5,1.1-1.1V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,5.4c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v5.5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1V5.4       z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v12c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1V1.1       z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,5.4c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v5.5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1       V5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27,8.5c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v2.4c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1V8.5z       "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2,5.4c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v5.5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1       V5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,1.1c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v12c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1V1.1       z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,5.4c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v5.5c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1       V5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.8,8.5c0-0.6-0.5-1.1-1.1-1.1c-0.6,0-1.1,0.5-1.1,1.1v2.4c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1       V8.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.4,27.2l-7-17.3v17.3h-1.5V7.9h2.2l7.1,17.7L83,7.9h2.1v19.3h-1.4V9.9L77,27.2H75.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.6,23.3c-0.7,2.5-2.8,4.2-5.8,4.2c-3.8,0-6.6-2.6-6.6-7.4c0-4.8,2.8-7.4,6.4-7.4c3.6,0,6.3,2.4,6.3,7.7       H89.7c0.1,4,2.4,5.8,5.2,5.8c2.1,0,3.7-1.1,4.2-3H100.6z M89.7,19.3h9.6c-0.2-3.6-2.2-5.3-4.8-5.3C92,14,90,15.8,89.7,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.2,27.2V13.2h1.2l0.2,2.7c0.8-2.1,2.2-3.1,3.9-3.1c0.6,0,1.1,0.1,1.4,0.2v1.4c-0.5-0.1-1-0.2-1.5-0.2       c-2,0-3.8,2-3.8,5.3v7.6H104.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.8,16.8c0.2-2.4,2.3-4,5.4-4c3.1,0,5.2,1.7,5.2,4.6v9.8h-1.2l-0.2-2.3c-0.9,1.4-2.4,2.7-4.9,2.7       c-2.7,0-4.7-1.5-4.7-3.9c0-2.4,1.4-3.8,5.4-4.5l4.2-0.7v-1.2c0-2-1.4-3.2-3.8-3.2c-2.2,0-3.6,1.1-3.8,2.8H112.8z M121.9,22.2v-2.6       l-3.8,0.6c-3.3,0.6-4.3,1.6-4.3,3.3c0,1.9,1.4,2.8,3.5,2.8C119.7,26.3,121.9,24.6,121.9,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M127.1,27.2V7.9h1.4v11l6.7-5.7h2l-7.2,6.1l8,7.9h-2l-7.6-7.4v7.4H127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.9,9.8v-2h1.7v2H139.9z M140,27.2V13.2h1.4v13.9H140z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCiscoMerakiLogoGreen);
export default __webpack_public_path__ + "static/media/cisco_meraki_logo_green.a43f05bc0a8deafa43ed2dbbdc1f1949.svg";
export { ForwardRef as ReactComponent };